import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const securityPlugin = createPlugin({
  id: 'security',
  routes: {
    root: rootRouteRef,
  },
});

export const SecurityPage = securityPlugin.provide(
  createRoutableExtension({
    name: 'SecurityPage',
    component: () =>
      import('./components/SecurityComponent').then(m => m.SecurityComponent),
    mountPoint: rootRouteRef,
  }),
);
